import React from 'react';

import './styles.css';

const SearchInput = ({onSearchChange, placeholder, onKeyPress}) => (
  <input
    className="SearchInput"
    type="text"
    placeholder={placeholder}
    onChange={onSearchChange}
    onKeyPress={onKeyPress}
  />
);

export default SearchInput;
